module.exports = __webpack_public_path__ + "static/media/course2.0939c5b0.png";